import { useMemo } from 'react'

import { type IntegrationNameEnum } from '@webapp/platform/integrations/entities/enums/IntegrationNameEnum'
import { useGetIntegrationsListPresenter } from '@webapp/platform/integrations/features/get-integrations-list/presenters/GetIntegrationsListPresenter'
import { integrationDetailsRegistry } from '../../config'

export interface IUseIntegrationDetailsPageProps {
  platform: IntegrationNameEnum
}
export const useIntegrationDetailsPage = ({
  platform,
}: IUseIntegrationDetailsPageProps) => {
  const {
    data: { integrations },
    states: { isLoading, isError },
  } = useGetIntegrationsListPresenter()

  const integration = useMemo(() => {
    if (!integrations) {
      return null
    }

    return integrations.find((i) => i.name === platform) ?? null
  }, [integrations, platform])

  const integrationLabel =
    integrationDetailsRegistry[platform]?.label ?? platform

  return {
    data: {
      integration,
      integrationLabel,
    },
    states: {
      isLoading,
      isError,
    },
  }
}
